import './style/index.css';
import App from './app';

export default App;
